window.VH = window.VH === undefined ? {} : window.VH;
VH.TomSelect = {
    tsList : {},
    counter : 0,

    setTS : function setTS() {
        let _t = VH.TomSelect,
            t = $(this),
            id = t.attr('id');

        if (t.hasClass('tomselected')) {
            return;
        }

        if (!id) {
            id = 'uTSId' + (_t.counter++);
            t.attr('id', id);
        }

        _t.tsList[id] = new TomSelect('#' + id, {
            plugins: ['clear_button'],
            render: {
                option: function (data, escape) {
                    // console.log([data, escape]);
                    return '<div class="' + data.$option.className + '">' + escape(data.text) + '</div>';
                },
                item: function (data, escape) {
                    // console.log([data, escape]);
                    return '<div class="' + data.$option.className + '">' + escape(data.text) + '</div>';
                }
            }
            //allowEmptyOption: true,
        });
    },

    init : function init(selector) {
        let _t = VH.TomSelect;
        selector = selector===undefined ? 'select.uTomSelect' : selector;
        $(selector).each(_t.setTS);
    }
};